module.exports = __webpack_public_path__ + "img/Frame-51.0444d7a3.svg";